/**
 * Created by dmitry on 17.10.2025
 */

const DoubleRewardsAdButton = cleverapps.UI.Button.extend({
    ctor: function (options) {
        this.multiplier = cleverapps.config.adRewardsMultiplier || 2;

        this._super({
            width: options.width,
            height: options.height,
            content: this.getContent(options),
            onClicked: this.onClicked.bind(this, options.victoryRewards, options.callback),
            type: options.type || cleverapps.styles.UI.Button.Images.button_green
        });

        this.addBadge(options);
        this.addAdIcon(options);
    },

    getContent: function (options) {
        const styles = cleverapps.styles.DoubleRewardsAdButton;
        const font = options.font || cleverapps.styles.FONTS.DOUBLE_REWARDS_AD_BUTTON_TEXT;
        const hardReward = options.victoryRewards.rewards.rewards.find((reward) => reward.type === "hard");
        const amount = hardReward && hardReward.value * this.multiplier;
        const text1 = new TextWithIcon(Messages.get("DoubleRewardsAdButton.text"), { font });
        // Default size (44/40) only applies when no custom font was passed in - an explicit
        // font.size (from options.font/amountFont) always wins, otherwise it'd be clobbered here.
        text1.setFontSize(options.font && options.font.size || 44);
        const amountFont = options.amountFont || font;
        const text2 = new TextWithIcon(`${TextWithIcon.ICONS_BY_NAME.hard} ${amount}`, {
            font: amountFont,
            icons: options.coinIcon && { [TextWithIcon.ICONS_BY_NAME.hard]: options.coinIcon },
            margin: options.amountMargin
        });
        text2.setFontSize(options.amountFont && options.amountFont.size || 40);

        let label = text1;
        if (options.beforeIcon) {
            const beforeIcon = new cc.Sprite(options.beforeIcon.frame);
            if (options.beforeIcon.width !== undefined || options.beforeIcon.height !== undefined) {
                // maxScale defaults to 1 in fitToBox - without it, a single-dimension resize
                // (only width or only height given) could never scale the icon up past its
                // native size, since the missing dimension falls back to that default cap.
                cleverapps.UI.fitToBox(beforeIcon, {
                    width: options.beforeIcon.width,
                    height: options.beforeIcon.height,
                    maxScale: Infinity
                });
            }
            const styleMargin = styles.beforeIconMargin !== undefined ? styles.beforeIconMargin : styles.margin;
            label = new cleverapps.Layout([beforeIcon, text1], {
                direction: cleverapps.UI.HORIZONTAL,
                margin: options.beforeIcon.margin !== undefined ? options.beforeIcon.margin : styleMargin
            });
        }

        return new cleverapps.Layout([label, text2], {
            direction: cleverapps.UI.VERTICAL,
            margin: options.contentMargin !== undefined ? options.contentMargin : styles.margin
        });
    },

    addBadge: function (options) {
        const styles = cleverapps.styles.DoubleRewardsAdButton.badge;
        const badge = new cc.Sprite((options.badge && options.badge.frame) || bundles.buttons.frames.double_rewards_ad_button_badge_png);
        if (options.badge && (options.badge.width !== undefined || options.badge.height !== undefined)) {
            cleverapps.UI.fitToBox(badge, {
                width: options.badge.width,
                height: options.badge.height,
                maxScale: Infinity
            });
        }
        badge.setAlignment(this.offsetAlignment(styles, options.badge && options.badge.position));
        this.addChild(badge);

        const font = (options.badge && options.badge.font) || cleverapps.styles.FONTS.DOUBLE_REWARDS_BADGE_TEXT;
        const label = cleverapps.UI.generateOnlyText(`x${this.multiplier}`, font);
        label.setAlignment(this.offsetAlignment(styles.label, options.badge && options.badge.labelPosition));
        badge.addChild(label);
    },

    // Adds an extra dx/dy on top of a base {x,y} alignment, without touching the default
    // alignment when no position override is passed - keeps other games' badges untouched.
    offsetAlignment: function (alignment, position) {
        if (!position) {
            return alignment;
        }

        return {
            ...alignment,
            x: position.x ? { ...alignment.x, dx: (alignment.x.dx || 0) + (position.x.dx || 0) } : alignment.x,
            y: position.y ? { ...alignment.y, dy: (alignment.y.dy || 0) + (position.y.dy || 0) } : alignment.y
        };
    },

    addAdIcon: function (options) {
        if (options.hideAdIcon) {
            return;
        }

        const styles = cleverapps.styles.DoubleRewardsAdButton.adIcon;
        const adIcon = new cc.Sprite(bundles.buttons.frames.double_rewards_ad_button_ad_icon_png);
        adIcon.setRotation(styles.rotation);
        adIcon.setAlignment(styles);
        this.addChild(adIcon);
    },

    onClicked: function (victoryRewards, callback) {
        cleverapps.rewardedAdsManager.playRewarded(
            AdsLimits.TYPES.FREEX2,
            () => {
                this.disable();
                this.multiplyRewards(victoryRewards);

                if (callback) {
                    callback();
                }
            }
        );
    },

    multiplyRewards: function (victoryRewards) {
        const { rewards, rewardsList } = victoryRewards;
        const hardReward = rewards.rewards.find((reward) => reward.type === "hard");
        if (hardReward) {
            const extraReward = new RewardsList({ hard: hardReward.value * (this.multiplier - 1) }, { event: rewards.options.event });
            extraReward.receiveRewards();

            const baseViewUpdate = hardReward.viewUpdate;
            hardReward.viewUpdate = () => {
                baseViewUpdate();
                extraReward.updateViewAmount();
            };

            hardReward.value *= this.multiplier;
        }

        const options = rewardsList.options;
        rewardsList.targets.forEach((target) => {
            const reward = target.reward;
            let prefix = options.noPrefix ? "" : RewardType.DEFAULT_PREFIX;
            if (options.prefix) {
                prefix = options.prefix;
            }

            let text = reward.getText(prefix);
            if (options.hideTextForSingleReward && reward.getAmount() === 1) {
                text = "";
            }

            target.text.setString(text);
        });
    }
});

DoubleRewardsAdButton.IsAvailable = function () {
    // the button doubles the hard reward, so a game that pays none (yatzy pays soft) gets tap-to-continue instead
    const hard = Game.currentGame && Game.currentGame.rewards && Game.currentGame.rewards.hard;
    if (!hard) {
        return false;
    }

    // level gate lives on the freex2 ad limit's `available`, which state() already checks
    return cleverapps.adsLimits.state(AdsLimits.TYPES.FREEX2) === AdsLimits.STATE_READY;
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    DOUBLE_REWARDS_AD_BUTTON_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },
    DOUBLE_REWARDS_BADGE_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    }
});

cleverapps.styles.DoubleRewardsAdButton = {
    margin: 0,

    badge: {
        x: { align: "right", dx: 30 },
        y: { align: "top", dy: 30 },
        label: {
            x: { align: "center", dx: 3 },
            y: { align: "center", dy: 6 }
        }
    },

    adIcon: {
        rotation: -30,
        x: { align: "left", dx: -20 },
        y: { align: "top", dy: 30 }
    }
};
